import { AlertType } from '../../../reducers/alert';
import { useAlert } from './useAlert';

export const useAlerts = () => {
    useAlert(AlertType.ALTITUDE);
    useAlert(AlertType.FUEL);
};
